module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('button', {
    staticClass: "mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-js-ripple-effect",
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "onClick": "return false"
    },
    on: {
      "click": function($event) {
        _vm.clicked()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons mdl-color-text--blue-grey-300"
  }, [_vm._v(_vm._s(_vm.icon))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4720a6d4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/elements/MiniFabButton.vue
// module id = 515
// module chunks = 1